// Open therapist SOS alerts, at the top of every admin page — 0273. Markup
// approved by Leon 2026-09-30.
//
// ⚠ NEVER AUTO-DISMISSES. A card leaves only when someone acknowledges it (the
// 2026-09-25 walkthrough: the SOS "clears only on explicit acknowledgement").
// Renders nothing at all when there is no open SOS, so it costs no layout.
//
// Not on /live-map: there the SOS is pinned on the map and in the map's own
// lane (SosMapLane), and a banner above it would only push the map down.

import { Button } from "@bednbody/ui/components/button";
import { Link } from "react-router-dom";
import { SosAlertCard } from "./SosAlertCard";
import { useOpenSosAlerts } from "./sos.hooks";
import { useSosAlarm } from "./useSosAlarm";

export function SosAlerts() {
  const { data: alerts } = useOpenSosAlerts();
  // Sound + a browser notification until someone acknowledges (sos.alarm.ts).
  useSosAlarm(alerts);

  if (!alerts || alerts.length === 0) return null;

  return (
    <section aria-label="Therapist SOS alerts" className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
      {alerts.map((alert) => (
        <SosAlertCard
          action={
            <Button
              className="flex-1"
              nativeButton={false}
              render={<Link to="/live-map" />}
              size="sm"
              variant="outline"
            >
              View on live map
            </Button>
          }
          alert={alert}
          key={alert.id}
        />
      ))}
    </section>
  );
}
